import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import Api from "../API/api";
import { loginState } from "../Atom/AtomState";
import { aesEncrypt } from "../Atom/Crypto";
import { localStorageBase64 } from "../Atom/localStorageBase64";
import "../CSS/PageCSS/LoginPage.css";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";

export default function LoginPage() {
  let navigate = useNavigate();
  const setLoginState = useSetRecoilState(loginState);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loginInformation, setLoginInformation] = useState({
    id: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const changeTextField = (value: any) => {
    if (value.name == "id") {
      setLoginInformation((prev) => ({
        ...prev,
        id: value.value,
      }));
    } else if (value.name == "password") {
      setLoginInformation((prev) => ({
        ...prev,
        password: value.value,
      }));
    }
  };

  const handleLogin = () => {
    const getLogin = async () => {
      setLoading(true);
      const formData = new FormData();
      formData.append("id", loginInformation.id);
      formData.append("password", aesEncrypt(loginInformation.password));

      const login = await Api.post(`/Login`, formData);
      setLoading(false);
      if (login != undefined) {
        setLoginState({
          p_id: login[0].p_id,
          name: login[0].name,
          manager: login[0].manager == 1 ? true : false,
        });
        localStorageBase64().setItem("accessToken", login[0].accessToken);
        localStorageBase64().setItem("refreshToken", login[0].refreshToken);
        navigate("/");
      } else {
        setAlert(true);
        setAlertMessage("로그인에 실패하였습니다.");
      }
    };
    if (loginInformation.id == "" || loginInformation.password == "") {
      setAlert(true);
      setAlertMessage("모든 값을 채워주세요.");
    } else {
      getLogin();
    }
  };

  return (
    <>
      <Box className="LoginContainer">
        <Card variant="outlined" className="loginCard">
          <Typography
            sx={{ typography: { sm: "h4", xs: "h6" } }}
            className="LoginTitle"
          >
            Ocollor Consult Login
          </Typography>
          <Box component="form" gap={2} className="LoginFormBox">
            <TextComponent
              variant="standard"
              value={loginInformation.id}
              required={true}
              label="ID"
              name="id"
              placeholder="아이디를 입력해주세요."
              fullWidth={true}
              onChange={changeTextField}
            />
            <TextComponent
              variant="standard"
              value={loginInformation.password}
              required={true}
              label="PASSWORD"
              placeholder="비밀번호를 입력해주세요."
              fullWidth={true}
              name="password"
              type={showPassword ? "text" : "password"}
              onChange={changeTextField}
              endAdornment={
                <IconButton
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                  style={{ marginRight: "10px" }}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              }
            />
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={handleLogin}
            >
              Login
            </ButtonComponent>
          </Box>
        </Card>
      </Box>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </>
  );
}
